import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WorkSheet } from 'xlsx';

interface Datasubject {
  data?: any;
  msg: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private message: NzMessageService,
  ) { }


  private dataSubject = new Subject<Datasubject>();
  subjectCode = {//subject code
    detectChanges: 'detectChanges',//刷新页面
    clearInspectionService: "clearInspectionService",//清空服务
    updateReportTable: 'updateReportTable',//更新报告表格
    updateSelectTab: 'updateSelectTab',//更新8*12的表格
  }
  // 向Subject发送数据
  sendData(data: Datasubject) {
    this.dataSubject.next(data);
  }
  // 订阅Subject，并返回Observable进行数据监听
  getData() {
    return this.dataSubject.asObservable();
  }

  // 下载表格
  /** 
   * @param formatData 数据，下载内容
   * @param fileName 文件名
   * @param tableName 表名
  */
  exportXlsx(formatData: any[], fileName: string, tableName: string): void {
    let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formatData)
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: [tableName] }
    const buffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    FileSaver.saveAs(data, fileName + '.xlsx');
  }


  // 下载多个表格
  /**
   * @param tables 数据，下载内容：key:表示表名，value为内容
   * @param fileName 文件名
   */
  downloadXlsxs(
    tables: {
      [key: string]: {
        data: { [key: string]: any }[],
        workSheet?: WorkSheet
      }
    },
    fileName: string,
  ) {
    try {
      let workBook: XLSX.WorkBook = { Sheets: {}, SheetNames: [] };
      for (let key in tables) {
        workBook.Sheets[key] = XLSX.utils.json_to_sheet(tables[key].data);
        if (tables[key].workSheet) {
          for (let sheetKey in tables[key].workSheet) {
            workBook.Sheets[key][sheetKey] = tables[key].workSheet?.[sheetKey]
          }
        }
        workBook.Sheets[key]['!merges']
        workBook.SheetNames.push(key);
        workBook.Sheets[key]
      }
      const buffer: any = XLSX.write(workBook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const data: Blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      FileSaver.saveAs(data, fileName + '.xlsx');
      this.message.success('下载成功');
    } catch (error) {
      this.message.error('下载失败');
    }
  }

  // 解析xlsx表格
  alalysisXlsx(file: any, isObject = false): Promise<any[]> {
    return new Promise((resolve, _) => {
      // 构建fileReader对象
      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        try {
          let result = e.target?.result;
          const wb: XLSX.WorkBook = XLSX.read(result, { type: 'binary' });
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          let dataInfo: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1 }); //解析出文件数据，可以进行后面操作
          dataInfo = dataInfo.filter(_ => _?.length);
          if (isObject) {
            let map = new Map();
            let xlsxHeader = dataInfo.shift();
            for (let i = 0; i < xlsxHeader!.length; i++) {
              map.set(i, xlsxHeader![i])
            }
            let res = [];
            for (let xlsxData of dataInfo) {
              res.push((() => {
                let obj: { [key: string]: any } = {};
                xlsxData.forEach((v, i: number) => {
                  obj[map.get(i)] = v
                })
                return obj
              })())
            }
            resolve(res);
            return;
          }
          resolve(dataInfo)
        } catch (error) {
          this.message.error('文件解析失败，可能是文件类型错误');
          resolve([])
        }
      }

      fileReader.readAsBinaryString(file)
    })
  }

  // downloadXlsxs(
  //   tables: { [key: string]: { [key: string]: any }[] },
  //   fileName: string
  // ) {
  //   try {
  //     let workBook: XLSX.WorkBook = { Sheets: {}, SheetNames: [] };
  //     for (let key in tables) {
  //       workBook.Sheets[key] = XLSX.utils.json_to_sheet(tables[key]);
  //       workBook.SheetNames.push(key);
  //     }
  //     const buffer: any = XLSX.write(workBook, {
  //       bookType: 'xlsx',
  //       type: 'array',
  //     });
  //     const data: Blob = new Blob([buffer], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  //     });
  //     FileSaver.saveAs(data, fileName + '.xlsx');
  //     this.message.success('下载成功');
  //   } catch (error) {
  //     this.message.error('下载失败');
  //   }
  // }
}
